



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component.html